<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-toolbar max-height="64">
      <v-toolbar-title>
        {{ $t("2fa.necessaryMeasure") }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text
      class="d-flex align-center justify-center px-5 flex-column white"
      style="height: 100%"
    >
      <p class="black--text justify-self-start body-2 pb-4">
        {{ $t("2fa.registerPhone") }}
      </p>
      <v-form @submit="submitPhone" style="width: 75%">
        <v-text-field
          style="width: 100%"
          v-model="phone"
          :label="$t('phone')"
          name="phone"
          type="tel"
          append-icon="mdi-phone"
          v-mask="'(##) #####-####'"
          solo
          :rules="[(v) => !!v || $t('thisFieldIsRequired')]"
          clearable
          autofocus
          tabindex="1"
        ></v-text-field>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            style="width: 100%"
            type="submit"
            @click.prevent="submitPhone"
            :color="disablePhoneSubmit ? 'grey' : 'primary'"
            :loading="loading"
            :class="{
              'disable-submit-otp': disablePhoneSubmit,
            }"
          >
            {{ $t("loginButton") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-form>
    </v-card-text>

    <v-dialog v-model="confirmPhoneDialog" max-width="600" persistent>
      <v-toolbar max-height="64">
        <v-toolbar-title>
          {{ $t("2fa.confirmPhoneTitle") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeConfirmPhoneDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text
        class="d-flex align-center justify-center px-5 flex-column white"
        style="height: 100%"
      >
        <h1 class="black--text justify-self-start body-2 pb-4">
          {{ $t("2fa.confirmPhone") }}
        </h1>

        <p class="black--text justify-self-start body-2">
          {{ $t("2fa.choosenPhone") }} <b>{{ newPhone }}</b>
        </p>

        <div style="width: 75%">
          <v-card-actions style="width: 100%">
            <v-btn
              style="width: 50%"
              type="submit"
              @click.prevent="cancelCurrentPhone"
              color="secondary"
            >
              {{ $t("toCancel") }}
            </v-btn>
            <v-btn
              style="width: 50%"
              type="submit"
              @click.prevent="submitCurrentPhone"
              color="primary"
            >
              {{ $t("loginButton") }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-card-text>
    </v-dialog>
  </v-dialog>
</template>

<script>
export default {
  props: ["dialog", "loading"],

  data: () => ({
    phone: "",
    newPhone: "",
    confirmPhoneDialog: false,
  }),

  computed: {
    disablePhoneSubmit() {
      return !this.phone || this.loading;
    },
  },

  watch: {
    dialog(val) {
      if (!val) {
        this.phone = "";
      }
    },
  },

  methods: {
    submitPhone() {
      const phone = this.phone.replace(
        // eslint-disable-next-line
        /[`~!@#$%^&*()_|+\-=?;:'",.<>/( )+/\{\}\[\]\\\/]/gi,
        ""
      );

      if (phone.length != 11) {
        const map = {
          pt: "Digite um número válido (DDD + Número)",
          en: "Please enter a valid number (DDD + Number)",
          es: "Introduza un número válido (DDD + Número)",
        };

        this.$store.commit("setFeedbackSnack", {
          msg: map[this.$i18n.locale],
          color: "warning",
        });

        return;
      }

      this.newPhone = this.phone;
      this.confirmPhoneDialog = true;
      this.$emit("closeDialog");
    },

    confirmPhone() {
      const phone = this.newPhone.replace(
        // eslint-disable-next-line
        /[`~!@#$%^&*()_|+\-=?;:'",.<>/( )+/\{\}\[\]\\\/]/gi,
        ""
      );

      this.$emit("doLogin", { phone, type: "submitPhone" });
    },

    closeDialog() {
      this.$emit("closeDialog");
    },

    cancelCurrentPhone() {
      this.closeConfirmPhoneDialog();
    },

    submitCurrentPhone() {
      this.confirmPhone();
      this.closeConfirmPhoneDialog();
    },

    closeConfirmPhoneDialog() {
      this.confirmPhoneDialog = false;
      this.phone = this.newPhone;
      this.$emit("openDialog");
    },
  },
};
</script>
